import { render, staticRenderFns } from "./ChangePasswordCard.vue?vue&type=template&id=17a2ca54"
import script from "./ChangePasswordCard.vue?vue&type=script&lang=js"
export * from "./ChangePasswordCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports